module.exports = __webpack_public_path__ + "img/album4-image-2.10ca7379.jpg";